<template>
  <div>
    <v-app-bar height="50" dense elevation="1" fixed app clipped-left style="background-color: black">
      <v-btn
        v-if="sidebar"
        small
        fab
        text
        @click.stop="drawerIsOpen = !drawerIsOpen"
      >
        <v-icon>mdi-menu</v-icon>
      </v-btn>
      <v-toolbar-title class="mr-3">
        <router-link to="/" tag="span" style="cursor: pointer">
          <img
            alt="logo"
            class="text-center d-flex align-center"
            style="width: 120px"
            src="@/assets/images/logo-active.svg"
          />
        </router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items v-if="hideMenu" class="hidden-md-and-down">
        <v-btn depressed text link href="/home" small>
          <v-icon left color="primary"> mdi-home </v-icon>
          Inicio
        </v-btn>

        <v-menu v-if="hasPermission(permissions.users.read)" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn depressed text small v-bind="attrs" v-on="on">
              <v-icon left color="primary"> mdi-cog-outline </v-icon>
              Configuración
            </v-btn>
          </template>
          <v-list>
            <v-list-item to="/usuarios">
              <v-list-item-title>Usuarios</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-menu offset-y v-if="hasPermission(permissions.project.read)">
          <template v-slot:activator="{ on, attrs }">
            <v-btn depressed text small v-bind="attrs" v-on="on">
              <v-icon left color="primary"> mdi-alien-outline </v-icon>
              Operaciones
            </v-btn>
          </template>
          <v-list>
            <v-list-item to="/proyectos">
              <v-list-item-title>Proyectos</v-list-item-title>
            </v-list-item>
            <v-list-item to="/ordenes?type=pwo">
              <v-list-item-title>Ordenes</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-menu offset-y v-if="canShowCommercialItem">
          <template v-slot:activator="{ on, attrs }">
            <v-btn depressed text small v-bind="attrs" v-on="on">
              <v-icon left color="primary"> mdi-account-tie-voice </v-icon>
              Comercial
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-if="
                hasPermission(permissions.projectQuotes.read) ||
                hasPermission(permissions.staffQuotes.read)
              "
              to="/cotizaciones?tab=0"
            >
              <v-list-item-title>Cotizaciones</v-list-item-title>
            </v-list-item>
            <v-list-item
              v-if="hasPermission(permissions.rates.showPrices)"
              to="/tarifas"
            >
              <v-list-item-title>Tarifas</v-list-item-title>
            </v-list-item>
            <v-list-item
              v-if="hasPermission(permissions.invoiceSwo.read) ||
              hasPermission(permissions.invoicePwo.read)"
              to='/facturas'
            >
              <v-list-item-title>Prefacturas</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              depressed
              text
              small
              class="text-capitalize"
              v-bind="attrs"
              v-on="on"
            >
              <v-avatar class="mr-2" size="30">
                <v-img :src="authUser.picture"></v-img>
              </v-avatar>
              <div v-if="authUser">{{ authUser.firstName }}</div>
            </v-btn>
          </template>
          <v-list tile dense>
            <v-list-item link>
              <v-list-item-title @click="logout"> Salir </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar-items>
    </v-app-bar>

    <v-navigation-drawer
      v-if="sidebar"
      v-model="drawerIsOpen"
      color="#f5f5f5"
      app
      clipped
      flat
    >
      <v-list>
        <v-list-item v-if="project">
          <v-avatar size="40" dark class="rounded" tile>
            <v-img :src="project.iconUrl"></v-img>
          </v-avatar>
        </v-list-item>

        <v-list-item v-if="project">
          <v-list-item-content>
            <v-list-item-title class="text-h6">
              <span class="text-lowercase text-capitalize">{{
                project.name
              }}</span>
            </v-list-item-title>
            <v-list-item-subtitle
              >Inicio: {{ formatDate(project.startDate) }}</v-list-item-subtitle
            >
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>
      <v-list v-if="project" nav dense>
        <v-list-item link :to="'/proyecto/' + project.id + '/sprints'">
          <v-list-item-icon>
            <v-icon color="primary">mdi-clock</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Sprints</v-list-item-title>
        </v-list-item>

        <v-list-item
          link
          :to="'/proyecto/' + project.id + '/ordenes-trabajo-proyecto'"
        >
          <v-list-item-icon>
            <v-icon color="primary">mdi-play-network</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Ordenes de trabajo PWO</v-list-item-title>
        </v-list-item>

        <v-list-item
          link
          :to="'/proyecto/' + project.id + '/ordenes-trabajo-staff'"
        >
          <v-list-item-icon>
            <v-icon color="primary">mdi-account-clock</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Ordenes de trabajo SWO</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import MENU_ITEMS_CONSTANTS from '@/constants/MenuItemsConstants'
import sessionMixin from '../../mixins/sessionMixin'
import loaderMixin from '../../mixins/loaderMixin'
import notificationMixin from '../../mixins/notificationMixin'
import crudServiceMixin from '../../mixins/crudServiceMixin'
import { AUTH_URL, PROJECT_URL } from '../../constants/ServicesConstants'
import dateMixin from '../../mixins/dateMixin'
import errorHandlerMixin from '../../mixins/errorHandlerMixin'
import PERMISSIONS from '../../constants/PermissionConstants'

export default {
  created () {
    this.getProject(this.$route.params.projectId)
  },
  computed: {
    authUser () {
      return this.getAuthUser()
    },
    sidebar () {
      return this.$route.meta.sidebar
    },
    canShowCommercialItem () {
      return (
        this.hasPermission(this.permissions.rates.read) ||
        this.hasPermission(this.permissions.projectQuotes.read) ||
        this.hasPermission(this.permissions.staffQuotes.read)
      )
    }
  },
  name: 'ProjectNavBar',
  props: {
    hideMenu: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      drawerIsOpen: true,
      menuItems: MENU_ITEMS_CONSTANTS,
      project: null,
      permissions: PERMISSIONS
    }
  },
  methods: {
    async logout () {
      try {
        this.showLoader()
        await this.post(AUTH_URL + '/logout', {
          token: this.authUser.token
        })
        this.clear()
        await this.$router.push({ path: '/' })
        this.hideLoader()
      } catch (e) {
        this.errorHandler(e)
        this.hideLoader()
      }
    },
    getProject (projectId) {
      if (this.$route.meta.sidebar && projectId) {
        this.showLoader()
        this.get(PROJECT_URL + '/' + projectId)
          .then((response) => {
            this.hideLoader()
            this.project = response.data
          })
          .catch((e) => {
            this.errorHandler(e)
            this.hideLoader()
          })
      }
    }
  },
  mixins: [
    sessionMixin,
    loaderMixin,
    notificationMixin,
    crudServiceMixin,
    dateMixin,
    errorHandlerMixin
  ],
  watch: {
    '$route.params.projectId' (projectId) {
      this.getProject(projectId)
    }
  }
}
</script>
<style>
.v-icon.notranslate.fas.fa-chevron-down.theme--light {
  font-size: 15px !important;
}

.theme--light.v-icon {
  color: #0055b8;
}
</style>
